module.exports = __webpack_public_path__ + "main/assets/public/form-card/right-arrow.fd181ac64809e748.svg";